import { render, staticRenderFns } from "./MyCentersInventory.vue?vue&type=template&id=fd8f3fc2&lang=pug&"
import script from "./MyCentersInventory.vue?vue&type=script&lang=js&"
export * from "./MyCentersInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports